export default __webpack_public_path__ + "CircularCustCapNum-Book.1302d93ee1c4407b6952dc7882ec63de.woff";